import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { FormField, Input } from '@wix/design-system';
import { useAppStore } from 'stores/state';

export const SelectSiteNameStepInput: FC = () => {
  const { t } = useTranslation();

  const siteName = useAppStore((state) => state.siteName);
  const setSiteName = useAppStore((state) => state.setSiteName);

  return (
    <FormField>
      <Input
        placeholder={t('select-site-name-step.input.placeholder')}
        onChange={(e) => setSiteName(e.target.value)}
        value={siteName}
      />
    </FormField>
  );
};
